import { render } from "./ModalNfse.vue?vue&type=template&id=2c0a8e32&scoped=true"
import script from "./ModalNfse.vue?vue&type=script&lang=js"
export * from "./ModalNfse.vue?vue&type=script&lang=js"

import "./ModalNfse.vue?vue&type=style&index=0&id=2c0a8e32&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0a8e32"]])

export default __exports__